import { render, staticRenderFns } from "./ItemsScroll.vue?vue&type=template&id=32e49bb8&scoped=true"
import script from "./ItemsScroll.vue?vue&type=script&lang=js"
export * from "./ItemsScroll.vue?vue&type=script&lang=js"
import style0 from "./ItemsScroll.vue?vue&type=style&index=0&id=32e49bb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e49bb8",
  null
  
)

export default component.exports